import { useQuery } from '@tanstack/react-query';
import { dishLanguages } from '../../../store/Dish/api';

export const useGetDishLanguages = ({ slug, enabled }) => {
    return useQuery(['dish-languages', slug], () => dishLanguages({ slug }), {
        enabled,
    });
};
